/* eslint-disable no-unused-vars */
import Vue from "vue";
import axios from "axios";
import moment from "moment";
import { getField, updateField } from "vuex-map-fields";

let defaultFilters = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    type: "all",
    query: null,
    client: null,
    collection: null,
    attributes: null
  };
};

let populatedFilters = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    type: params.get("type") ? params.get("type") : "all",
    query: params.get("query"),
    client: params.get("client") ? parseInt(params.get("client")) : null,
    collection: params.get("collection")
      ? parseInt(params.get("collection"))
      : null,
    attributes: params.get("attributes")
  };
};

let state = {
  loading: true,
  filters: populatedFilters(),
  sorting: {
    field: "updated_at",
    order: "desc"
  },
  pagination: {
    page: 1,
    totalRows: 0,
    perPage: 15
  },
  searchResults: null,
  clients: []
};

const mutations = {
  updateField,
  setPagination(state, data) {
    state.pagination.page = data.current_page;
    state.pagination.from = data.from;
    state.pagination.to = data.to;
    state.pagination.lastPage = data.last_page;
    state.pagination.perPage = data.per_page;
    state.pagination.totalRows = data.total;
  },
  setPage(state, pageNr) {
    state.pagination.page = pageNr;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setSearchResults(state, results) {
    state.searchResults = [...results];
  },
  setAttributes(state, attributes) {
    state.filters.attributes = attributes;
  },
  setClients(state, clients) {
    state.clients = clients;
  },
  setClientAndCollection(state, filters) {
    state.filters.type = "all";
    state.filters.client = filters.client;
    state.filters.collection = filters.collection;
  },
  setCollection(state, collection) {
    state.filters.collection = collection;
  },
  clearFilters(state) {
    state.filters = defaultFilters();
  }
};

const actions = {
  search({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit("setLoading", true);

      let params = new URLSearchParams();

      for (const filter in state.filters) {
        if (
          state.filters.hasOwnProperty(filter) &&
          state.filters[filter] !== null &&
          filter !== "attributes"
        ) {
          params.set(filter, state.filters[filter]);
        }
      }

      history.replaceState(null, "", "?" + params.toString());

      axios
        .get(`/api/smart-vault/search`, {
          params: {
            ...state.filters,
            ...state.sorting,
            page: state.pagination.page
          }
        })
        .then(resp => {
          commit("setPagination", resp.data);
          commit("setSearchResults", resp.data.data);
          resolve(resp.data.data);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit("setLoading", false);
        });
    });
  }
};

const getters = {
  getField
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
